import { createContext, useContext, type ReactNode } from 'react';
import type { ScriptTranslationState } from '../hooks/useScriptTranslation';

const ScriptTranslationContext = createContext<ScriptTranslationState | null>(null);

export function ScriptTranslationProvider({
  value,
  children,
}: {
  value: ScriptTranslationState;
  children: ReactNode;
}) {
  return (
    <ScriptTranslationContext.Provider value={value}>
      {children}
    </ScriptTranslationContext.Provider>
  );
}

export function useScriptTranslationContext(): ScriptTranslationState {
  const ctx = useContext(ScriptTranslationContext);
  if (!ctx) {
    throw new Error(
      'useScriptTranslationContext must be used inside <ScriptTranslationProvider>',
    );
  }
  return ctx;
}
